import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import AppProvider from './AppProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(AppProvider);

reportWebVitals();
